// material-ui
import { useTheme } from "@mui/material/styles";

// project-import

import { Typography } from "@mui/material";
import { Stack } from "@mui/system";
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

export default function LogoMain({ reverse }: { reverse?: boolean }) {
  const theme = useTheme();
  return (
    /**
     * if you want to use image instead of svg uncomment following, and comment out <svg> element.
     *
     * <img src={theme.palette.mode === ThemeMode.DARK ? logoDark : logo} alt="Mantis" width="100" />
     *
     */
    <>
      <Stack
        direction={"row"}
        spacing={1.5}
        height="100%"
        maxHeight={"50px"}
        alignItems="center"
      >
        {/* <img
          style={{
            height: "100%",
            maxHeight: "50px",
            mixBlendMode: "multiply",
          }}
          src="https://d1f11tvnfjqryd.cloudfront.net/Images/ITMBU_Logo.png"
        />
        <Typography variant="h3">ITMBU Alumni</Typography> */}

        {/* <img
          style={{
            height: "100%",
            maxHeight: "50px",
            mixBlendMode: "multiply",
          }}
          src="https://d2beora143tsok.cloudfront.net/Upload/Logo/IU_FullLogo.png"
        />
        <Typography variant="h3">IU Alumni</Typography> */}

        {/* <img
          style={{
            height: "100%",
            maxHeight: "50px",
            mixBlendMode: "multiply",
          }}
          src="https://d2ocuppja9d4fr.cloudfront.net/Upload/Logo/GN_FullLogo.png"
        /> */}

        {/* <img
          style={{
            height: "100%",
            maxHeight: "50px",
            mixBlendMode: "multiply",
          }}
          src="https://d3t0f9jpt2fds8.cloudfront.net/Upload/Logo/SirMVIT_Alumni_Logo.png"
        /> */}

        {/* <img
          style={{
            height: "100%",
            maxHeight: "50px",
            mixBlendMode: "multiply",
          }}
          src="https://d3nbc713tplvd1.cloudfront.net/Upload/Logo/Rai_SmallLogo.png"
        />
        <Typography variant="h3">Rai Alumni</Typography> */}

        {/* <img
          style={{
            height: "100%",
            maxHeight: "50px",
            mixBlendMode: "multiply",
          }}
          src="https://d3fb03zx5h21st.cloudfront.net/Upload/Logo/DSU_Small.png"
        />
        <Typography variant="h3">DSI Alumni</Typography> */}

        {/* <img
          style={{
            height: "100%",
            maxHeight: "50px",
            mixBlendMode: "multiply",
          }}
          src="https://d1ravyl4xj14l2.cloudfront.net/Upload/Logo/Geetanjali_SmallLogo.png"
        />
        <Typography variant="h3">GU Alumni</Typography> */}

        {/* <img
          style={{
            height: "100%",
            maxHeight: "50px",
            mixBlendMode: "multiply",
          }}
          src="https://d3a4jls59ro43h.cloudfront.net/Upload/Logo/MEU_SmallLogo.jpg"
        />
        <Typography variant="h3">MEU Alumni</Typography> */}

        <img
          style={{
            height: "100%",
            maxHeight: "50px",
            mixBlendMode: "multiply",
          }}
          src="https://d39itv4llo32q2.cloudfront.net/Upload/Logo/DDU_SmallLogo.png"
        />
        <Typography variant="h3">DDU Alumni</Typography>
      </Stack>
    </>
  );
}
